// ==================================== COMPONENTS =========================================
// THIRD PARTY/ CORE COMPONENTS
import { Col, Row, Skeleton, Spin } from 'antd';
import PropTypes from 'prop-types';
import React, { Suspense, useEffect } from 'react';

// USER'S COMPONENTS
import { Cards } from '../../../components/cards/frame/cards-frame';
import Heading from '../../../components/heading/heading';
import { PageHeader } from '../../../components/page-headers/page-headers';
import { Main } from '../../styled';
import { ProductDetailsWrapper } from '../../car/Style';
import CarAmigoInfo from '../../car/overview/CarAmigoInfo';
import { useDispatch, useSelector } from 'react-redux';
import { getImportedCarIds } from '../../../redux/carImport/carAmigo/actionCreator';

const ImportedCarMetaDetail = ({ match }) => {
  const dispatch = useDispatch()
  const { apiLoading, allImportedCarIds, allImportedCarIdsFetched } = useSelector(state => ({
    apiLoading: state.carAmigo.apiLoading,
    allImportedCarIds: state.carAmigo.allImportedCarIds,
    allImportedCarIdsFetched: state.carAmigo.allImportedCarIdsFetched
  }));

  useEffect(() => {
  if (!allImportedCarIdsFetched && !apiLoading) {
    dispatch(getImportedCarIds());
  }
}, [allImportedCarIdsFetched, apiLoading, dispatch]);

  let car = allImportedCarIds.find(item => item._id === match?.params.id)

  if (car && Object.keys(car).length > 0) {
    const { name, brand, model, image, price, statusPrice } = car.meta;
    return (
      <>
        <PageHeader ghost title="Car Details" />
        <Main>
          <Cards headless>
            <ProductDetailsWrapper>
              <div className="product-details-box">
                <Row gutter={30}>
                  <Col xs={24} lg={10}>
                    <div className="product-details-box__left pdbl">
                      <figure>
                        <img
                          src={
                            image
                              ? `${image}`
                              : require(`../../../static/img/noimage.png`)
                          }
                          alt={`img_${name}`}
                          height={300}
                          style={{ width: '100%', objectFit: 'contain' }}
                        />
                      </figure>
                    </div>
                  </Col>
                  <Col xs={24} lg={14}>
                    <Suspense
                      fallback={
                        <Cards headless>
                          <Skeleton active />
                        </Cards>
                      }
                    >
                      <div className="product-details-box__right pdbr">
                        <Heading className="pdbr__title" as="h4">
                          {name}
                        </Heading>
                        {/* BASIC DETAILS */}
                        <p
                          style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            marginTop: '-10px',
                          }}
                        >
                          <span className="pdbr__brand-text" style={{ flex: 1, paddingTop: '10px' }}>
                            Name :
                          </span>
                          <span className="pdbr__brand-name" style={{ flex: 3, alignItems: 'flex-start' }}>
                            {name}
                          </span>
                        </p>
                        <p
                          style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            marginTop: '-10px',
                          }}
                        >
                          <span className="pdbr__brand-text" style={{ flex: 1, paddingTop: '10px' }}>
                            Brand :
                          </span>
                          <span className="pdbr__brand-name" style={{ flex: 3, alignItems: 'flex-start' }}>
                            {brand ?? 'NA'}
                          </span>
                        </p>
                        <p
                          style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            marginTop: '-10px',
                          }}
                        >
                          <span className="pdbr__brand-text" style={{ flex: 1, paddingTop: '10px' }}>
                            Model :
                          </span>
                          <span className="pdbr__brand-name" style={{ flex: 3, alignItems: 'flex-start' }}>
                            {model ?? 'NA'}
                          </span>
                        </p>
                        <p
                          style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            marginTop: '-10px',
                          }}
                        >
                          <span className="pdbr__brand-text" style={{ flex: 1, paddingTop: '10px' }}>
                            Price :{' '}
                          </span>
                          <span className="pdbr__brand-name" style={{ flex: 3, alignItems: 'flex-start' }}>
                            {new Intl.NumberFormat('fr-FR').format(price)} {process.env.REACT_APP_DEFAULT_CURRENCY}
                            {' '}{statusPrice}
                          </span>
                          
                        </p>
                      </div>
                    </Suspense>
                  </Col>
                </Row>
                <Row>
                  {car?.sourceId && (
                    <CarAmigoInfo carAmigoId={car.sourceId} carName={name} variant={'row'} />
                  )}
                </Row>
              </div>
            </ProductDetailsWrapper>
          </Cards>
        </Main>
      </>
    );
  }

  if (apiLoading) {
    return (
      <Col xs={24}>
        <div className="spin">
          <Spin />
        </div>
      </Col>
    );
  }

  return (
    <h4 style={{ fontSize: 30, height: '50vh', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
      Car Not Found
    </h4>
  );
};

ImportedCarMetaDetail.propTypes = {
  match: PropTypes.object,
};

export default ImportedCarMetaDetail;
